// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import CalendarOutlinedSvg from "@fishx/icons-svg/es/asn/CalendarOutlined";
import FishxIcon from '../components/FishxIcon';

var CalendarOutlined = function CalendarOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: CalendarOutlinedSvg
  }));
};

CalendarOutlined.displayName = 'CalendarOutlined';
export default React.forwardRef(CalendarOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/CalendarOutlined.js
// module id = 2145
// module chunks = 0